'use client'

import { useUpdateSearchParams } from '@/core/hooks/use-update-search-params'
import { Select, SelectItem } from '@heroui/select'
import { useTranslations } from 'next-intl'

export function SortByFilter() {
  const { searchParams, updateSearchParam } = useUpdateSearchParams()

  const sort =
    searchParams.get('sorting') === 'created_at.asc' ? 'oldest' : 'newest'
  const onSortChange = (value: string) => {
    if (value === 'oldest') {
      updateSearchParam({ sorting: 'created_at.asc' })
    } else {
      updateSearchParam({ sorting: 'created_at.desc' })
    }
  }
  const t = useTranslations()
  return (
    <Select
      placeholder={t('search.sortBy')}
      size='sm'
      id='select'
      className='text-mountain-bluebird max-w-sm'
      classNames={{
        base: '!w-[100px] cursor-pointer',
        trigger: 'border border-black text-mountain-bluebird ',
        value: 'text-mountain-bluebird ',
        mainWrapper: 'w-full',
        selectorIcon: 'static',
      }}
      onChange={e => {
        onSortChange(e.target.value)
      }}
      value={sort}
    >
      <SelectItem key='newest'>{t('search.Newest')}</SelectItem>
      <SelectItem key='oldest'>{t('search.Oldest')}</SelectItem>
    </Select>
  )
}
